import { UserDetailsWebComponent } from './component/UserDetailsWebComponent';

export { UserDetailsWebComponent };
